// src/components/ProtectedComponent.js

import React from 'react';
// This assumes you have a context hook named 'useAuth' to get the user.
// If you use Redux or something else, get the user from there.
// THIS IS THE CORRECT PATH
import { useAuth } from '../auth/AuthContext.jsx';
/**
 * A component that renders its children only if the logged-in user
 * has the required permission.
 * 
 * @param {object} props
 * @param {string} props.requiredPermission The permission string to check for (e.g., "read-user").
 * @param {React.ReactNode} props.children The content to render if the user has permission.
 */
const ProtectedComponent = ({ requiredPermission, children }) => {
    // We get the 'hasPermission' function from our AuthContext.
    // This is the cleanest way to check permissions.
    const { hasPermission } = useAuth();

    // If the user has the permission, render the children (the NavLink).
    // Otherwise, render nothing (null).
    if (hasPermission(requiredPermission)) {
        return <>{children}</>;
    }

    return null;
};

export default ProtectedComponent;